const viewportMeta = document.querySelector('meta[name="viewport"]')
const defaultValue = viewportMeta.getAttribute('content')

export function disableZoom() {
    viewportMeta.setAttribute('content', `${defaultValue}, minimum-scale=1, maximum-scale=1, user-scalable=no`)
}

export function enableZoom() {
    viewportMeta.setAttribute('content', defaultValue)
}